import { types } from 'mobx-state-tree'

export const SequenceEvent = types.model('SequenceAudioEvent', {
  extraTime: 0,
  fileName: types.string,
  length: types.number,
  type: types.literal('audio'),
})

export type ISequenceEvent = typeof SequenceEvent.Type

export enum SequenceIcon {
  intro = 'intro',
  meditation = 'meditation',
  quote = 'quote',
  silence = 'silence',
  setup = 'setup',
  question = 'question',
  ending = 'ending',
  mailinglist = 'mailinglist',
  partner = 'partner'
}

export const SequenceItem = types.model('SequenceItem', {
  events: types.array(SequenceEvent),
  icon: types.maybe(types.enumeration('Icon', Object.keys(SequenceIcon))),
  image: types.maybe(types.string),
  partner: types.maybe(types.union(types.literal('one'), types.literal('two'))),
  source: types.maybe(types.string),
  title: types.string,
}).views(self => ({
  get totalLength() {
    return self.events.reduce((sum, event) => {
      return sum + event.length
    }, 0)
  }
}))

export type ISequenceItem = typeof SequenceItem.Type

export const ModuleDetails = types.model('ModuleDetails', {
  textIntro: types.string,
  textSell: types.string,
  textStart: types.string,
  title: types.string,
})

export const Script = types
  .model('Module', {
    details: ModuleDetails,
    sequence: types.array(SequenceItem),
    shortname: types.string,
  })
  .views(self => ({
    get totalLength() {
      const total = self.sequence.reduce((sum, item) => {
        return sum + item.totalLength
      }, 0)

      return Math.floor(total)
    },
    get cardCount() {
      const filteredCards = self.sequence.filter(item => !item.partner)

      return filteredCards.length
    }
  }))

export type IScript = typeof Script.Type

export enum ScriptState {
  inactive = 'inactive',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}

export const ScriptStore = types.model('ScriptStore', {
  data: types.maybe(Script),
  state: types.optional(
    types.enumeration('ScriptState', Object.keys(ScriptState)),
    ScriptState.inactive
  ),
}).actions(self => ({
  reset() {
    self.data = null
    self.state = ScriptState.inactive
  }
}))

export type IScriptStore = typeof ScriptStore.Type


// WEBPACK FOOTER //
// ./src/models/script.ts